import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import TwentyTwenty from './vue/components/twenty-twenty/TwentyTwenty.vue';

header();
initMain([], {
    TwentyTwenty
});